/*import { REFRESH_DASHBOARD } from "../actions/dashboard";

const initialState = {
  disciplines: [],
};

export default function dashboardReducer(state = initialState, action) {
  switch (action.type) {
    case REFRESH_DASHBOARD:
      return { ...state, disciplines: action.payload };
    default:
      return state;
  }
}
*/
// reducers/dashboard.js
import {
  REFRESH_DASHBOARD_REQUEST,
  REFRESH_DASHBOARD_SUCCESS,
  REFRESH_DASHBOARD_FAILURE,
  UPDATE_RENCONTRE_STATUS,
} from "../actions/dashboard";

const initialState = {
  disciplines: [],
  loading: false,
  error: null,
  lastUpdated: null,
};

const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case REFRESH_DASHBOARD_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case REFRESH_DASHBOARD_SUCCESS:
      return {
        ...state,
        loading: false,
        // ⚡ Correction : utiliser directement action.payload
        disciplines: Array.isArray(action.payload)
          ? action.payload
          : [action.payload],
        error: null,
        lastUpdated: new Date().toISOString(),
      };

    case REFRESH_DASHBOARD_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_RENCONTRE_STATUS:
      // Met à jour les données localement si nécessaire
      return {
        ...state,
        disciplines: state.disciplines.map((discipline) => {
          // Ici tu peux mettre la logique pour modifier le statut
          return discipline;
        }),
        lastUpdated: new Date().toISOString(),
      };

    default:
      return state;
  }
};

export default dashboardReducer;
